import "../css/ServicesPage.css";

import React from "react";
import WeAreHere from "./WeAreHere";
import OccupationTherapyIntro from "./OccupationTherapyIntro";

const ServicesPage = () => {
  return (
    <div className="services-container">
      {/* <WeAreHere />
      <OccupationTherapyIntro/> */}
    </div>
  );
};

export default ServicesPage;
